export const ensureString = (
  key: string,
  value?: any,
  defaultValue?: string,
): string => {
  if (typeof value !== 'string') {
    if (defaultValue !== undefined) return defaultValue
    throw new Error(`${key}: ${value} must be string`)
  }
  return value as string
}

const booleanTypes: Array<any> = ['false', 'true', false, true, '0', '1', 0, 1]
export const ensureBoolean = (
  key: string,
  value?: any,
  defaultValue?: boolean,
): boolean => {
  if (!booleanTypes.includes(value)) {
    if (defaultValue !== undefined) return defaultValue
    throw new Error(`${key}: ${value} must be boolean`)
  }

  return value === 'true' || value === '1' || value === 1 || value === true
}

export const assertKey = (key: any) => {
  if (
    key === 'undefined' ||
    key === undefined ||
    key === null ||
    key === 'null' ||
    key.length === 0
  ) {
    throw new Error(`key is not valid`)
  }
}
